import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import SettingsModal from '../modals/SettingsModal';

const Layout: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [showSettingsModal, setShowSettingsModal] = useState(false);
  
  // Add escape key listener to close sidebar on mobile
  useEffect(() => {
    const handleEscKey = (event: KeyboardEvent) => {
      // Only close sidebar with ESC key on mobile devices
      const isMobile = window.innerWidth < 768; // 768px is the md breakpoint in Tailwind
      if (event.key === 'Escape' && isSidebarOpen && isMobile) {
        setIsSidebarOpen(false);
      }
    };
    
    window.addEventListener('keydown', handleEscKey);
    return () => window.removeEventListener('keydown', handleEscKey);
  }, [isSidebarOpen]);
  
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  
  return (
    <div className="flex h-screen bg-background-dark text-gray-200 relative overflow-hidden">
      {/* Background elements for visual appeal */}
      <div className="fixed top-20 left-20 w-96 h-96 bg-primary-900/20 rounded-full filter blur-3xl opacity-20"></div>
      <div className="fixed bottom-20 right-20 w-96 h-96 bg-secondary-900/20 rounded-full filter blur-3xl opacity-20"></div>
      
      {/* Sidebar */}
      <div
        className={`fixed md:static inset-y-0 left-0 z-20 shadow-md transform transition-transform duration-300 ease-in-out
        ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'}
        `}
      >
        <Sidebar onOpenSettings={() => setShowSettingsModal(true)} />
      </div>
      
      {/* Mobile overlay */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-10 md:hidden"
          onClick={() => setIsSidebarOpen(false)}
        ></div>
      )}
      
      {/* Main content */}
      <div className="flex flex-col flex-1 overflow-hidden">
        <Header 
          toggleSidebar={toggleSidebar} 
          isSidebarOpen={isSidebarOpen} 
        />
        
        <main className="flex-1 overflow-y-auto p-6 bg-background-dark">
          <div className="max-w-7xl mx-auto animate-fade-in">
            <Outlet />
          </div>
        </main>
      </div>

      {/* Settings Modal */}
      <SettingsModal 
        isOpen={showSettingsModal} 
        onClose={() => setShowSettingsModal(false)} 
      />
    </div>
  );
};

export default Layout; 